"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFacilityContactCreateDto = instanceOfFacilityContactCreateDto;
exports.FacilityContactCreateDtoFromJSON = FacilityContactCreateDtoFromJSON;
exports.FacilityContactCreateDtoFromJSONTyped = FacilityContactCreateDtoFromJSONTyped;
exports.FacilityContactCreateDtoToJSON = FacilityContactCreateDtoToJSON;
exports.FacilityContactCreateDtoToJSONTyped = FacilityContactCreateDtoToJSONTyped;
/**
 * Check if a given object implements the FacilityContactCreateDto interface.
 */
function instanceOfFacilityContactCreateDto(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    return true;
}
function FacilityContactCreateDtoFromJSON(json) {
    return FacilityContactCreateDtoFromJSONTyped(json, false);
}
function FacilityContactCreateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'phoneNumber': json['phoneNumber'],
        'email': json['email'],
        'isPrimary': json['isPrimary'] == null ? undefined : json['isPrimary'],
        'title': json['title'] == null ? undefined : json['title'],
    };
}
function FacilityContactCreateDtoToJSON(json) {
    return FacilityContactCreateDtoToJSONTyped(json, false);
}
function FacilityContactCreateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'phoneNumber': value['phoneNumber'],
        'email': value['email'],
        'isPrimary': value['isPrimary'],
        'title': value['title'],
    };
}
//# sourceMappingURL=FacilityContactCreateDto.js.map